import { FC, useCallback } from 'react';
import { observer } from "mobx-react-lite";
import cancelIcon from "../../../assets/cancel.svg";

export interface ICancelButtonProps {
    onClickFunc: () => void;
}

const BtnCancel: FC<ICancelButtonProps> = observer(({ onClickFunc }) => {
    const handleClick = useCallback(() => {
        onClickFunc();
    }, [onClickFunc]);

    return (
        <button 
            className="button-base btn_margin-left" 
            onClick={handleClick}
            type="button"
            aria-label="Отмена"
        >
            <img src={cancelIcon} alt="Отмена" />
        </button>
    );
});

export default BtnCancel;